import { useStore } from 'react-redux'
import { AppStore } from '../redux/store'

/**
 * The store itself, for reading state *after* an await rather than during a
 * render (COM-974).
 *
 * `useAppSelector` gives a render-time snapshot, which is the right instrument
 * almost everywhere: a component that renders from it re-renders when it
 * moves. A callback that runs a network round trip later is the exception —
 * the snapshot it closed over is as old as the request, and nothing re-runs
 * the callback when the store moves underneath it. The boot prefetch hooks hit
 * exactly that: the session they fetch is what flips
 * `config.options.hidePricesActive`, so the value they need is written by
 * their own round trip and cannot be in the snapshot they started from.
 *
 * Prefer `useAppSelector` for anything a render reads. Reach for this only
 * where the read is deliberately *not* reactive.
 */
export const useAppStore = useStore.withTypes<AppStore>()

export default useAppStore
